import { DataTableColumn } from 'app2/components';

export type DataTableColumnTransform<T> = (cols: DataTableColumn<T>[]) => DataTableColumn<T>[];

export function transformCols<T extends DataTableColumn = any>(fns:DataTableColumnTransform<T>[], cols:(DataTableColumn<T> | string)[]):DataTableColumn<T>[] {
  return fns
    .filter(fn => !!fn)
    .reduce((cols, fn) => fn(cols as any), cols) as DataTableColumn<T>[];
}
